import { useState } from 'react';
import { Divider, Button, Box } from '@mui/material';
import strings from '../../../common/Translation/Translate';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import { fetchFromStorage } from '../../../utils/storage';
import { identifiers } from '../../../utils/constants/identifiers';
import { downloadExportFile } from '../../../utils/validators/HelperFunctions';
import PageLoader from '../../../components/PageLoader';
import Upload from '../../../components/Upload/Upload';
import Config from '../../../utils/Config';
import axios from 'axios';

const ListPageImportDrawerComponent = ({ isLoading, setIsLoading, setOpenDrawer, setMessage, importApi, downloadTempateApi }: any) => {
    const [files, setFiles] = useState<any>([]);
    const token = fetchFromStorage(identifiers.access_token);

    const downloadImportBooking = async () => {
        try {
            setIsLoading(true);
            axios({
                url: `${Config.BaseURL + downloadTempateApi}`,
                method: 'GET',
                data: {},
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            })
                .then((response: any) => {
                    setIsLoading(false);
                    downloadExportFile(response, 'xlsx', `template`);
                })
                .catch(err => {
                    setIsLoading(false);
                });
        } catch (error: any) {
            setIsLoading(false);
            if (error.response) {
                setMessage({
                    display: true,
                    severity: 'error',
                    message: error.response.data?.error_description
                        ? error.response.data.error_description
                        : error.response.data.message,
                })
            } else {
                setMessage({
                    display: true,
                    severity: 'error',
                    message: error.message
                })
            }
        }
    };

    const handleUpload = async () => {
        if (files?.length > 0) {
            try {
                setIsLoading(true);
                const body = new FormData();
                files?.forEach((file: any) => {
                    body.append('file', file);
                });
                if (files?.length === 0) {
                    body.append('file', null as any);
                }
                axios({
                    url: `${Config.BaseURL + importApi}`,
                    method: 'POST',
                    data: body,
                    headers: { Authorization: `Bearer ${token}` },
                    responseType: 'blob',
                })
                    .then((response: any) => {
                        setIsLoading(false);
                        setOpenDrawer(false);
                        setMessage({
                            display: true,
                            severity: 'success',
                            message: strings.import_success,
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 406) {
                            downloadExportFile(error.response.data, 'xlsx', 'errorFile');
                            setMessage({
                                display: true,
                                severity: 'error',
                                message: strings.import_booking_error,
                            });
                        }
                        else if (error?.response?.status === 403) {
                            setMessage({
                                display: true,
                                severity: 'error',
                                message: strings.forbidden,
                            });
                        }
                        else {
                            if (error.response) {
                                setMessage({
                                    display: true,
                                    severity: 'error',
                                    message: error.response.data?.error_description
                                        ? error.response.data.error_description
                                        : error.response.data.message,
                                })
                            } else {
                                setMessage({
                                    display: true,
                                    severity: 'error',
                                    message: error.message
                                })
                            }
                        }
                        setIsLoading(false);
                    });
            } catch (error: any) {
                setIsLoading(false);
                if (error.response.status === 406) {
                    downloadExportFile(error.response.data, 'xlsx', 'errorFile');
                    setMessage({
                        display: true,
                        severity: 'error',
                        message: strings.import_booking_error,
                    });
                } else {
                    if (error.response) {
                        setMessage({
                            display: true,
                            severity: 'error',
                            message: error.response.data?.error_description
                                ? error.response.data.error_description
                                : error.response.data.message,
                        })
                    } else {
                        setMessage({
                            display: true,
                            severity: 'error',
                            message: error.message
                        })
                    }
                }
            }
        }
    };

    return (
        <Box py={2}>
            {isLoading && <PageLoader />}
            <Button
                sx={{ '.MuiButton-endIcon': { m: 0 } }}
                onClick={downloadImportBooking}
                variant="contained"
                endIcon={<DownloadRoundedIcon />}>
                {strings.download_template_text}
            </Button>
            <Divider sx={{ my: 2 }} />
            <Upload
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                inputValue={files}
                textChange={value => setFiles(value)}
            />
            <Button
                disabled={files?.length === 0}
                onClick={handleUpload}
                variant="contained"
                endIcon={<FileUploadRoundedIcon />}>
                {strings.import_booking_button}
            </Button>
        </Box>
    );
};
export default ListPageImportDrawerComponent;
